import { Box } from '@hover/blueprint';
import type { ReactNode } from 'react';
import React from 'react';

interface FooterProps {
  children: ReactNode;
}

const Footer = ({ children }: FooterProps) => (
  <Box alignItems="center" display="grid">
    {children}
  </Box>
);

export { Footer };
